import { BRAND, TEAM } from "../data/index.js";

function Avatar({ initials, size = 80 }) {
  return (
    <div
      className="rounded-full flex items-center justify-center font-bold text-white bg-green-700 mx-auto mb-4"
      style={{ width: size, height: size, fontSize: size * 0.3 }}
    >
      {initials}
    </div>
  );
}

export default function TeamPage({ dark }) {
  const ceo = TEAM.find((t) => t.isCEO);
  const rest = TEAM.filter((t) => !t.isCEO);

  return (
    <>
      <div className={`pt-20 min-h-screen ${dark ? "bg-green-950 text-white" : "bg-green-50/60 text-green-900"}`}>

        {/* Hero banner */}
        <div className={`relative py-20 ${dark ? "bg-green-900/60" : "bg-green-800"}`}>
          {/* Dot pattern */}
          <div
            className="absolute inset-0 opacity-[0.04] pointer-events-none"
            style={{
              backgroundImage: "radial-gradient(circle at 2px 2px, rgba(255,255,255,.8) 1px, transparent 0)",
              backgroundSize: "40px 40px",
            }}
          />
          <div className="max-w-4xl mx-auto px-4 text-center text-white relative z-10">
            <span className="inline-block text-xs font-semibold tracking-widest uppercase px-4 py-1.5 rounded-full mb-5 bg-green-400/10 text-green-400">
              Our People
            </span>
            <h1 className="font-serif text-4xl md:text-5xl font-bold mb-4">Meet the Team</h1>
            <p className="text-green-300/80 text-base">
              The hearts and minds behind Global Exclusive Ariel Farm Ltd
            </p>
          </div>
        </div>

        <div className="max-w-5xl mx-auto px-4 sm:px-6 py-16">

          {/* CEO feature */}
          {ceo && (
            <div className={`rounded-2xl p-8 sm:p-12 mb-16 border
              ${dark ? "bg-green-900/30 border-green-400/10" : "bg-white border-green-200"}`}>
              <div className="flex flex-col sm:flex-row gap-8 items-center sm:items-start">
                <div className="flex-shrink-0 text-center">
                  {ceo.photo
                    ? <img
                        src={ceo.photo}
                        alt={ceo.name}
                        className="w-36 h-36 rounded-full object-cover border-4 border-green-600"
                      />
                    : <Avatar initials={ceo.initials} size={144} />
                  }
                  <div className="mt-3">
                    <span className="inline-block px-3 py-1 rounded-full text-xs font-bold text-white bg-green-700">
                      CEO & Founder
                    </span>
                  </div>
                </div>
                <div>
                  <h2 className={`font-serif text-3xl font-bold mb-1 ${dark ? "text-white" : "text-green-900"}`}>
                    {ceo.name}
                  </h2>
                  <p className="text-sm font-medium mb-4 text-green-600">{ceo.board}</p>
                  <blockquote className={`text-base leading-relaxed italic ${dark ? "text-green-300/80" : "text-green-700/80"}`}>
                    "{ceo.speech}"
                  </blockquote>
                </div>
              </div>
            </div>
          )}

          {/* Team grid */}
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {rest.map((m) => (
              <div
                key={m.name}
                className={`rounded-2xl p-6 text-center border transition-all duration-200 hover:-translate-y-1 hover:shadow-xl
                  ${dark
                    ? "bg-green-900/30 border-green-400/10 hover:border-green-400/30"
                    : "bg-white border-green-200 hover:border-green-400"}`}
              >
                {m.photo
                  ? <img
                      src={m.photo}
                      alt={m.name}
                      className="w-20 h-20 rounded-full object-cover mx-auto mb-4 border-4 border-green-600"
                    />
                  : <Avatar initials={m.initials} size={80} />
                }
                <h3 className={`font-semibold text-base ${dark ? "text-white" : "text-green-900"}`}>
                  {m.name}
                </h3>
                <p className="text-sm mt-1 text-green-600">{m.role}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}